export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">关于我们</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            致力于打造优质的国产影视在线观看平台
          </p>
        </div>
        <div className="max-w-4xl mx-auto bg-background-50 rounded-2xl p-6 md:p-10">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            91视频网站诞生于对国产影视的热爱与坚持。我们专注于汇集91年及经典年代的国产影片、电视剧和综艺节目，为广大影迷提供一个免费、高清、流畅的在线观影平台。从怀旧经典到热门新剧，从电影佳作到综艺精选，我们持续更新片源，确保每一位访问者都能找到心仪的内容。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            我们的内容覆盖国产电影、电视剧、综艺、纪录片等多个类别，特别关注91年国产影片这一具有特殊意义的影视时期。平台采用先进的视频分发技术，保障高清画质与流畅播放，让您随时随地重温那些难忘的国产影视记忆。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            91视频网站坚持免费开放的运营理念，每日更新最新影视资源，致力于成为国产影视爱好者的首选在线观影社区。
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8 pt-6 border-t border-background-200">
            {[
              { num: '15+', label: '运营年数' },
              { num: '20000+', label: '影片资源' },
              { num: '500万+', label: '月活用户' },
              { num: '99.9%', label: '服务可用' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-xl md:text-2xl font-black text-primary-500">{stat.num}</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}